import styled from 'styled-components';
import { StyledAdminListHeaders } from '../../AdminListHeaderCell/styles/StyledAdminListHeaders';

export const StyledAdminPaymentHistoryListHeader = styled.div`
  ${StyledAdminListHeaders}

  .admin-list-header-cell-container {
    &.id,
    &.status,
    &.createdat,
    &.updatedat {
      flex-basis: initial;
      flex-grow: 0;
    }
    &.id {
      width: 10.4rem;
    }
    &.status {
      width: 14.4rem;
    }
    &.createdat,
    &.updatedat {
      width: 23.8rem;
    }
  }
`;
